import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'

//import 'vuetify/src/stylus/app.styl'

Vue.use(Vuetify)

const opts = {
  iconfont: 'md',
  theme: {
    themes: {
      light: {
        //CRN Bar colours from left to right
        //Match theme primary to nihrNavy
        primary: '#193E72',
        secondary: '#EA5D4E',
        crngreen: '#76bc43',        //NHS Light Green
        crndarkgreen: '#006648',    //NHS Darg Green
        crnorange: '#f08c21',      //NHS Orange
        crnppink: '#9a0050',       //NHS Dark Pink
        crnred: '#e1261c',          //NHS Red
        crnpurple: '#312565',     //NHS Purple
        crnblue: '#0072cf',          //NHS Bright Blue
        nihrNavy: '#193E72',
        nihrCoral: '#EA5D4E',
        nihrOrange: '#F29330',
        nihrYellow: '#FED47A',
        nihrPurple: '#6667AD',
        nihrAqua: '#2EA9B0',
        nihrGreen: '#46A86C',
        nihrGrey: '#ACBCC3'
      },
      dark: {
        //CRN Bar colours from left to right
        //Match theme primary to nihrNavy
        primary: '#193E72',
        secondary: '#EA5D4E',
        crngreen: '#76bc43',        //NHS Light Green
        crndarkgreen: '#006648',    //NHS Darg Green
        crnorange: '#f08c21',      //NHS Orange
        crnppink: '#9a0050',       //NHS Dark Pink
        crnred: '#e1261c',          //NHS Red
        crnpurple: '#312565',     //NHS Purple
        crnblue: '#0072cf',          //NHS Bright Blue
        nihrNavy: '#193E72',
        nihrCoral: '#EA5D4E',
        nihrOrange: '#F29330',
        nihrYellow: '#FED47A',
        nihrPurple: '#6667AD',
        nihrAqua: '#2EA9B0',
        nihrGreen: '#46A86C',
        nihrGrey: '#ACBCC3'
      }
    }
  }
}


export default new Vuetify(opts)
